import Vue from 'vue'
import Vuex from 'vuex'
import common from "./modules/common";
import dictionary from "./modules/dictionary";
import getters from "./getters";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    common,
    dictionary
  }
})
